export default __webpack_public_path__ + "static/media/apple.1b53a532.svg";